import React from 'react';

const ResultadoFinal = ({ puntuacion, rango, modo, tiempoRestante }) => {

  const renderResultadoEspecifico = () => {
    switch (modo) {
      case 'Clásico':
        return (
          <p>Tu rango es: {rango}</p>
        );
      case 'Sin fallos':
        return (
          <p>
            {puntuacion === 30
              ? "¡Felicidades! Has respondido todas las preguntas correctamente."
              : "Aún puedes mejorar este resultado. ¡Sigue intentándolo!"}
          </p>
        );
      case 'Contrarreloj':
        return (
          <p>
            {tiempoRestante > 0 && puntuacion === 60 ? (
              `¡Increíble! Has contestado correctamente todas las preguntas en ${30 - tiempoRestante} segundos.`
            ) : tiempoRestante > 0 ? (
              `¡Buen trabajo! Has respondido todas las preguntas, pero tu puntuación aún puede mejorar. ¡Sigue practicando!`
            ) : puntuacion >= 30 ? (
              `¡Se acabó el tiempo! Hiciste un excelente trabajo, pero aún puedes mejorar tu puntuación. ¡Sigue practicando!`
            ) : (
              `¡Se acabó el tiempo! Tu puntuación es mejorable, así que no dejes de intentarlo.`
            )}
          </p>
        );
      default:
        return null;
    }
  };

  return (
    <div>
      <h2>¡Quiz completado!</h2>
      <p>
        {modo === 'Clásico'
          ? `Tu puntuación final es: ${puntuacion} de 10`
          : `Tu puntuación final es: ${puntuacion}`}
      </p>
      {renderResultadoEspecifico()}
    </div>
  );
};

export default ResultadoFinal;
